import { useMutation } from "react-query";
import http from "infra/http";

function useDeleteUnidadeUnificada() {
  return useMutation(
    `/v1/unidades-unificadas`,
    (id: string) => http.delete(`/v1/unidades-unificadas/${id}`),
    { retry: false }
  );
}

export default useDeleteUnidadeUnificada;
